import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import { px2rem } from '@utils/px2rem'
interface H5SidebarUserInfoProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    userInfo?: any;
    publishType?: any;
    topicId?: any;
    userClick?: Function;
    loginClick?: Function;
    publishClick?: Function;
}

@inject('app', 'site', 'user')
@observer
class H5SidebarUserInfo extends React.Component<H5SidebarUserInfoProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        // const { data, avatarUrl, size, userCode, userClick, isOfficialFirst, isOfficialSecond, officialSize = 24 } = this.props;
        return <>
            <div className={styles.userInfoBox}>
                
            </div>
        </>;

    }
}

export default H5SidebarUserInfo;